import { Button } from "primereact/button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import '../css/Dashboard.css';
import { useEffect, useState } from "react";
import ManageUsers from "../components/ManageUsers";
import ManageUserArticles from "../components/ManageUserArticles";
import ManageWeblog from "../components/ManageWeblog";
import ManageOrders from "../components/ManageOrders";
import { apiClient } from "../apiClient";
import { useOnlineStatus } from "../context/OnlineContext";
import colors from '../colors';



function ManagerDashboardPage(props)
{
  const user = JSON.parse(localStorage.getItem('seo_app'))
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem('userToken'));
  const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
  const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);
  const location = useLocation();
  const currentPath = location.pathname; 
  const { online, setOnline } = useOnlineStatus();



  //if user cache is lost or user is not a manager, go to home page:
  useEffect(() => 
    {
  

        

        if(!user)
            navigate("/login");
        
            //check role:
            apiClient.get(process.env.REACT_APP_BACK+"/users/role/"+user?._id, config)
            .then((response) => {
              if (response.status == 200)
              {
                  if(response.data != "manager")
                    navigate("/404");
              }
                
            })
            .catch((error) => {
              console.log("axios error",error);
           
            });
  
    });


    //logout user:
  const logout = () => 
  {
    console.log("atemped to log out");
  
    apiClient.get(process.env.REACT_APP_BACK+"/users/logout", config)
    .then((response) => {
      if (response.status == 200)
      {
        // Set online status to false
        setOnline(false);

        navigate("/");
      }
      console.log(response);
    })
    .catch((error) => {
      console.log("axios error");
   
    });

    //delete user cache:
    localStorage.removeItem('seo_app');
    localStorage.removeItem('userToken');

  
  }

 

  //check desktop or laptop:
  useEffect(() => {
    window
    .matchMedia("(min-width: 768px)")
    .addEventListener('change', e => setDesktop( e.matches ));
  }, []);

    return(

        <div id="manager">

    {desktop ? 

    <div id="nav-bar-wrap" style={{width:"6%"}}>
      {/* <div id="logo-icon">
      <Link to="/">
          <img src={require("../images/logo.png")} alt={process.env.REACT_APP_ALT}/>
      </Link>
      </div> */}

      <div id="nav-icons">

      <div className="nav-bar-item">

      <Link to="/manager-dashboard">
      <Button tooltip="خانه" tooltipOptions={{position:"left"}} 
      className={currentPath === "/manager-dashboard" ? "focused-button" : ""}>
        <i className="pi pi-home"></i>
      </Button>
      </Link>
      </div>

      <div className="nav-bar-item">
      <Link to="/manager-dashboard/orders">
      <Button tooltip="سفارش ها" tooltipOptions={{position:"left"}}
      className={currentPath === "/manager-dashboard/orders" ? "focused-button" : ""}>
        <i className="pi pi-pen-to-square"></i>
      </Button>
      </Link>
      </div>


      <div className="nav-bar-item">

      <Link to="/manager-dashboard/users">
      <Button tooltip="کاربران" tooltipOptions={{position:"left"}}
      className={currentPath === "/manager-dashboard/users" ? "focused-button" : ""}>
        <i className="pi pi-user"></i>
      </Button>
      </Link>
      </div>


        <div className="nav-bar-item">

          <Link to="/manager-dashboard/articles">
          <Button tooltip="مقاله ها" tooltipOptions={{position:"left"}}
          className={currentPath === "/manager-dashboard/articles" ? "focused-button" : ""}>
            <i className="pi pi-file"></i>
          </Button>
          </Link>
        </div>

        <div className="nav-bar-item">
        <Link to="/manager-dashboard/weblog">
          <Button id="search-button" tooltip="وبلاگ" tooltipOptions={{position:"left"}}
          className={currentPath === "/manager-dashboard/weblog" ? "focused-button" : ""}>
            <i className="pi pi-book"></i>
          </Button>
          </Link>
        </div>


        


      <div className="nav-bar-item">
          
          
          <Button id="dashboard-logout-button" tooltip="خروج" tooltipOptions={{ position: 'left'}} onClick={logout}>
        <i className="pi pi-power-off"></i>
          </Button>
          
          
          
        </div>

       
      </div>

     
      </div>

      :null}

      <div id="manager-panel">
        
        {props.type === "articles" ? <ManageUserArticles/>: null}
        {props.type === "users" ? <ManageUsers/>: null}
        {props.type === "weblog" ? <ManageWeblog/>: null}
        {props.type === "orders" ? <ManageOrders/>: null}
        {props.type === "dashboard" ? 
        <div style={{paddingBottom: "100px"}}>
          <div >
            <h3>سلام 
              {" "+user?.name+" "}
              عزیز،
            </h3>
            <h3 style={{color:'#219B9D', marginBottom:'100px'}}>به داشبورد مدیریت خوش آمدید</h3>
            </div>



      

      <div className="intro-container" style={{marginTop:"10px"}}>

      <div className="intro-item" onClick={()=>{navigate("/manager-dashboard/orders")}}>
                <i className="pi pi-pen-to-square"></i>
                <h4 className="title">مدیریت سفارش ها</h4>
                <p className="subtitle">مدیریت سفارش های کاربران</p>
            </div>
    
            <div className="intro-item" onClick={()=>{navigate("/manager-dashboard/users")}}>
                <i className="pi pi-users"></i>
                <h4 className="title">مدیریت کاربران</h4>
                <p className="subtitle">مدیریت کاربران ثبت شده</p>
            </div>

            
            <div className="intro-item" onClick={()=>{navigate("/manager-dashboard/articles")}}>
                <i className="pi pi-file"></i>
                <h4 className="title"> مدیریت مقاله ها</h4>
                <p className="subtitle">مدیریت مقاله های کاربران</p>
            </div>

            <div className="intro-item" onClick={()=>{navigate("/manager-dashboard/weblog")}}>
                <i className="pi pi-book"></i>
                <h4 className="title">مدیریت وبلاگ</h4>
                <p className="subtitle">مدیریت وبلاگ و مقاله های سایت</p>
            </div>

            

            

            

         
            

      </div>
        </div>

        
        
        : null}

      </div>


    {/* mobile nav ********************************************************************************/}
    {!desktop ? 

    <div 
    id="mobile-manager-nav"
    style={{position: "fixed",bottom:"0",direction:"rtl",width:"100%",background:"#ffffff",boxShadow: "rgba(0, 0, 0, 0.81) 0px 1px 4px"}}>

    <span style={{display:"flex"}} id="nav-icons">

    <span style={{display:"flex",direction:"rtl",width:"85%"}}>

      <div className="nav-bar-item">
       <div id="logo-icon">
      <Link to="/manager-dashboard">
          <img src={require("../images/logo.png")} alt={process.env.REACT_APP_ALT}/>
      </Link>
      </div>
      </div>

      <div className="nav-bar-item">
      <Link to="/manager-dashboard/orders">
          <Button id="search-button">
            <i className="pi pi-pi-pen-to-square"></i>
          </Button>
      </Link>
      </div>

      <div className="nav-bar-item">
      <Link to="/manager-dashboard/users">
          <Button>
            <i className="pi pi-users"></i>
          </Button>
      </Link>
      </div>

      <div className="nav-bar-item">
      <Link to="/manager-dashboard/articles">
          <Button id="search-button">
            <i className="pi pi-file"></i>
          </Button>
      </Link>
      </div>


      <div className="nav-bar-item">
      <Link to="/manager-dashboard/weblog">
          <Button id="search-button">
            <i className="pi pi-book"></i>
          </Button>
      </Link>
      </div>

      


     

    

  
  

      <div className="nav-bar-item">
      
      <Button onClick={logout}>
            <i className="pi pi-sign-out"></i>
          </Button>
      
      </div>

      </span>
      
   

    </span>
    </div>
    : null}

{/********************************************************************************************/}


    </div>

            

    );
}

export default ManagerDashboardPage;